import { request } from "./requests";


export function isDownloadable(shortcode) {
    return request({
        url: `/d/chk/${shortcode}`,
        method: 'get',  // 默认就是 get，可以不用写
        retriable: true
    })
}



// WEBPACK FOOTER //
// ./src/data/download.js